import React, { Component } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Segment, Header } from "semantic-ui-react";

import UserDetailsRequestForm from "../../components/sentry/UserDetailsRequestForm.jsx";
import UserDetailsRequestFormResult from "../../components/sentry/UserDetailsRequestFormResult.jsx";
import LinkWithReset from "../../components/utils/LinkWithReset.jsx";

import {
  passwordRequest,
  resetPasswordStore
} from "../../state/reducers/account/accountActions.js";
import { selectCopy } from "../../state/reducers/locale/copySelector.js";

class PasswordRequest extends Component {
  static propTypes = {
    isFetching: PropTypes.bool.isRequired,
    isSuccess: PropTypes.bool.isRequired,
    passwordRequest: PropTypes.func.isRequired,
    resetPasswordStore: PropTypes.func.isRequired,
    copyKey: PropTypes.string.isRequired,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    copyKey: "sentry.password_request"
  };

  constructor(props) {
    super(props);

    this.props.resetPasswordStore();
  }

  // -- HANDLERS -- //

  onSubmit = values => {
    this.props.passwordRequest(values);
  };

  // -- RENDER -- //

  renderForm = () => {
    const { isFetching, isSuccess, copyKey } = this.props;

    if (isSuccess) {
      return (
        <UserDetailsRequestFormResult copyKey="sentry.password_request_result" />
      );
    }

    return (
      <UserDetailsRequestForm
        isFetching={isFetching}
        copyKey={copyKey}
        onSubmit={this.onSubmit}
      />
    );
  };

  render() {
    const { copyKey, copy } = this.props;

    return (
      <div className="sentry-form">
        <Header as="h3" inverted>
          {copy(`${copyKey}.title`)}
        </Header>
        <Segment padded textAlign="left">
          {this.renderForm()}
        </Segment>
        <footer>
          <LinkWithReset to="/">{copy(`${copyKey}.login_cta`)}</LinkWithReset>
        </footer>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isFetching: state.password.isFetching,
  isSuccess: state.password.isSuccess,
  copy: selectCopy(state)
});

const mapDispatchToProps = dispatch => ({
  passwordRequest: data => dispatch(passwordRequest(data)),
  resetPasswordStore: () => dispatch(resetPasswordStore())
});

export default connect(mapStateToProps, mapDispatchToProps)(PasswordRequest);
